export default "__VITE_ASSET__DD110GMs__"